module.exports = __webpack_public_path__ + "assets/img/contactbj.36874d43.png";